var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { SocialIcons } from "./social-icons";
import DOMPurify from "dompurify";
import SHARE_OPTIONS from "./share-options";
export default class PageBuilder {
  constructor() {
    __publicField(this, "customAvatar", "https://cdn.filestackcontent.com/Aoba6jBccRfypjdfz6rPLz/auto_image/compress/%22http://hypes-images.s3.amazonaws.com/assets/analytics/EmptyProfile.png%22");
    __publicField(this, "socialIcons", new SocialIcons());
    __publicField(this, "isShareButtonsVisible", false);
    __publicField(this, "displayError", (errorMsg) => {
      return ` <img src='https://cdn.hypemarks.com/assets/splash5/Logo_Icon_warmRed_@2x.png' alt='Tint' style="display: block; margin: 0 auto 24px">
    <h1>${errorMsg}</h1>`;
    });
    __publicField(this, "createTemplate", (data) => {
      var _a, _b, _c;
      if (data.hasError) return this.displayError("We can not fetch data. Please try again later.");
      const postsData = data.posts;
      const personalizationData = data.personalizations;
      if (!postsData || !personalizationData)
        return this.displayError("Post does not exist anymore or has private status.");
      const { url, video_url: videoUrl, image_url: imageUrl, title, text, published_at: date } = postsData == null ? void 0 : postsData.attributes;
      const { image_url: authorImageUrl, username: userName, name, url: authorUrl } = (_a = postsData == null ? void 0 : postsData.attributes) == null ? void 0 : _a.author;
      const shareButtons = (_b = personalizationData == null ? void 0 : personalizationData.attributes) == null ? void 0 : _b.share_buttons;
      const formatDate = new Date(date).toLocaleString("en-us", { day: "numeric", month: "short", year: "numeric" });
      const shareButtonsElements = ((_c = personalizationData == null ? void 0 : personalizationData.attributes.data) == null ? void 0 : _c.sharebuttonoptions) || [];
      return `
      <div class='tint-public-posts-page'>
        <div class='tint-public-posts-page__container'>
            ${this.renderThumbSection({ imageUrl, videoUrl, url, title })}
           <div class='tint-public-posts-page__content'>
             <div class='author'>
                ${authorUrl ? `
                <a href=${authorUrl} target='_blank' rel='noopener noreferrer'>
                  <img src='${authorImageUrl || this.customAvatar}' alt='${name || ""}'/>
                </a>` : `<img src='${authorImageUrl || this.customAvatar}' alt='${name || ""}'/>`}
                
                <div class='author__details'>
                  ${authorUrl ? `<a href=${authorUrl} target='_blank' rel='noopener noreferrer'>
                      ${name ? `<span class='author-name'>${name}</span>` : ""}
                      ${userName ? `<span class='author-username'>@${userName}</span>` : ""}
                   </a>` : `
                    ${name ? `<span class='author-name'>${name}</span>` : ""}
                    ${userName ? `<span class='author-username'>@${userName}</span>` : ""}
                  `}
                </div>
           </div>
           <p class='description'>${DOMPurify.sanitize(text)}</p>
            <footer class='tint-public-posts-page__footer'>
              <p class='date'>${formatDate}</p>
              <div class='share-buttons'>
                ${shareButtons ? `<span onclick="onShareButtonClick()">
                  ${this.renderShareButtons()}
                </span>` : ""}
                ${this.renderShareElements({ shareButtonsElements, url, text, imageUrl })}
              </div>
            </footer>
          </div>
        </div>
      </div>
    `;
    });
    __publicField(this, "getSocialIcon", (type) => {
      switch (type) {
        case "tw":
          return this.socialIcons.twitterIcon;
        case "fb":
          return this.socialIcons.fbIcon;
        case "li":
          return this.socialIcons.linkedInIcon;
        case "pin":
          return this.socialIcons.pinterestIcon;
        case "email":
          return this.socialIcons.emailIcon;
        default:
          return;
      }
    });
    __publicField(this, "renderShareElements", ({ shareButtonsElements, url, text, imageUrl }) => {
      const shareElements = shareButtonsElements.map(
        (el) => `<li class="share-option" onclick='onShareButtonClick()'>
        <a href="${SHARE_OPTIONS[el].getUrl({ link: url, title: text, body: imageUrl })}" 
          class='share-option__link'
          target='_blank' rel='noopener noreferrer'
        >
          ${this.getSocialIcon(el)}
          <span class='share-name'>${SHARE_OPTIONS[el].name}</span>
        </a>
      </li>`
      ).join("");
      return `<ul>${shareElements}</ul>`;
    });
    __publicField(this, "renderShareButtons", () => {
      return `
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="share-alt" role="img"
           xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
           className="svg-inline--fa fa-share-alt fa-w-14 fa-2x">
        <path fill="currentColor"
              d="M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
              className="fa-2x"></path>
      </svg>
      `;
    });
    __publicField(this, "renderThumbSection", ({ imageUrl, videoUrl, url, title }) => {
      return `${imageUrl || videoUrl ? `
      <div class='tint-public-posts-page__thumb'>
        <a href=${url} target='_blank' rel='noopener noreferrer'>
          ${imageUrl && !videoUrl ? `<img src=${imageUrl} alt=${title} />` : ""}
          ${videoUrl ? `
                          <video
                            controls
                            class='tint-exb-video-container__video'
                            muted
                            playsinline
                          >
                           <source src=${videoUrl}#t=0.1 />
                        </video>
                    ` : ""}</a>
      </div>` : ""}`;
    });
    __publicField(this, "onShareButtonClick", () => {
      this.isShareButtonsVisible = !this.isShareButtonsVisible;
      const shareButtonEl = document.querySelector(".share-buttons");
      shareButtonEl.classList.toggle("expanded");
    });
  }
  render(container, data) {
    return __async(this, null, function* () {
      window.onShareButtonClick = this.onShareButtonClick;
      container.innerHTML = this.createTemplate(data);
      document.addEventListener("click", (e) => {
        const element = document.querySelector(".share-buttons");
        if (e.target !== element && !element.contains(e.target)) {
          element.classList.remove("expanded");
        }
      });
    });
  }
}
